<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="600px"
    append-to-body
    :before-close="close"
  >
    <el-form
      :model="editForm"
      ref="editFormRef"
      label-width="100px"
      :rules="rules"
    >
      <el-form-item label="分享链接" prop="shareUrl">
        <el-input v-model="editForm.shareUrl" placeholder="请输入分享链接">
          <template #prepend>{{ getHost() }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="分享密码" prop="sharePassword">
        <el-input
          v-model="editForm.sharePassword"
          placeholder="请输入分享密码"
        />
      </el-form-item>
      <el-form-item label="访问一次" prop="shareOne">
        <el-radio-group v-model="editForm.shareOne">
          <dictionary-radio code="yesNo" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示用户信息" prop="showUserInfo">
        <el-radio-group v-model="editForm.showUserInfo">
          <dictionary-radio code="yesNo" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="editForm.status">
          <dictionary-radio code="commonStatus" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分享标签" prop="shareTag">
        <el-input v-model="editForm.shareTag" placeholder="请输入分享标签" />
      </el-form-item>
      <el-form-item label="分享简介" prop="shareIntroduction">
        <el-input
          v-model="editForm.shareIntroduction"
          type="textarea"
          rows="3"
          placeholder="请输入分享简介"
        ></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleSave" :loading="editLoading"
          >确 定</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'

import { getById, update } from '@/api/nav/share'

const { proxy } = getCurrentInstance()

const visible = ref(false)
const title = ref('')
const editLoading = ref(false)
const rules = ref({
  shareUrl: [{ required: true, message: '分享链接不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'blur' }]
})
const editForm = ref({
  id: undefined,
  shareUrl: undefined,
  sharePassword: undefined,
  shareOne: undefined,
  visitCount: undefined,
  shareIntroduction: undefined,
  shareTag: undefined,
  showUserInfo: undefined,
  status: undefined
})

/**
 * 显示弹窗
 */
async function show(id) {
  visible.value = true
  title.value = '修改导航分享'
  // 获取分享信息
  const { data } = await getById(id)
  editForm.value = data
  editForm.value.shareOne = editForm.value.shareOne + ''
  editForm.value.showUserInfo = editForm.value.showUserInfo + ''
  editForm.value.status = editForm.value.status + ''
}

/**
 * 关闭
 */
function close() {
  visible.value = false
  reset()
}

/**
 * 重置
 */
function reset() {
  proxy.resetForm('editFormRef')
}

/**
 * 提交数据
 */
const emit = defineEmits(null)
function handleSave() {
  proxy.$refs.editFormRef.validate(async (valid) => {
    if (valid) {
      editLoading.value = true
      try {
        // 修改
        await update(editForm.value)
        proxy.$modal.msgSuccess('修改导航分享成功')
        emit('fetch-data')
        close()
      } finally {
        editLoading.value = false
      }
    }
  })
}

defineExpose({
  show
})
</script>
